<template>
    <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-col cols="12" sm="12" md="12" >
                {{ allow_reexam_marks_entry }}
                <v-row dense class="p-0 m-0" v-if="scheme_details!=''">
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Subject Code" readonly dense outlined rounded v-model="scheme_details[0].crs_code"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Subject Name" readonly dense outlined rounded v-model="scheme_details[0].crs_name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Teacher" readonly dense outlined rounded v-model="scheme_details[0].inst_name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Standard" readonly dense outlined rounded v-model="scheme_details[0].standard"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Division" readonly dense outlined rounded v-model="scheme_details[0].division"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Academic Year" readonly dense outlined rounded v-model="scheme_details[0].academicyear"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Assessment Type" readonly dense outlined rounded v-model="scheme_details[0].assessmenttype"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Evaluation Type" readonly dense outlined rounded v-model="scheme_details[0].evaluationtype"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Entry Type" readonly dense outlined rounded v-model="scheme_details[0].coursemarksentrytype"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Evaluated Marks" readonly dense outlined rounded v-model="scheme_details[0].evaluated_marks"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="p-0 m-0">
                        <v-text-field color="#0F2027" label="Converted Marks" readonly dense outlined rounded v-model="scheme_details[0].converted_marks"></v-text-field>
                    </v-col>
                </v-row>
                <v-row dense no-gutters align="center" class="p-0 m-0" v-if="scheme_details[0].learners.length > 0">
                    <v-col class="p-0 m-0 d-flex align-center" cols="12" sm="3" md="3">
                        <v-btn rounded color="success" class="mb-0 pb-0" small @click="exportToExcel">
                            <v-icon left small>mdi-file-excel</v-icon>
                            Export to Excel
                        </v-btn>
                    </v-col>
                    <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                        <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                    </v-col>
                    <v-col class="pt-3 mt-3 d-flex align-center" cols="12" sm="3" md="3">
                        <v-chip outlined label color="#0F2027">Evaluated Marks :: {{ scheme_details[0].evaluated_marks }}</v-chip>
                    </v-col>
                </v-row>
                <v-row v-if="!scheme_details[0].expire">
                    <v-col class="d-flex justify-center">
                        <span class="slide">Marks Entry Date Is Over..!</span>
                    </v-col>
                </v-row>
                <span v-if="scheme_details[0].learners.length > 0">
                    <v-data-table v-if="allow_reexam_marks_entry && tabs == 1" dense :headers="headers4" :items="scheme_details[0].learners" :search="search" class="elevation-1 mytable">
                        <template v-slot:item.is_applied_for_reexam="{ item }">
                            <input
                            type="checkbox"
                            v-model="item.is_applied_for_reexam">
                        </template>
                        <template v-slot:item.options="{ item }">
                            <input v-if="item.is_applied_for_reexam == true" placeholder="Enter marks." class="input text-center"  type="number" v-model="item.reexam_evaluated_marks" :name="item.cid" :rules="[v => !!v || 'Required' || v >= 0]" @keypress="isNumber($event)"  @change="check_marks(item.reexam_evaluated_marks,scheme_details[0].evaluated_marks)"/>
                        </template>
                    </v-data-table>

                    <v-data-table v-else dense :headers="headers3" :items="scheme_details[0].learners" :search="search" class="elevation-1 mytable">
                        <template v-slot:item.isabsent="{ item }">
                        <input
                            type="checkbox"
                            v-model="item.isabsent"
                            :disabled="item.medical_leave"
                            @change="handleAbsentChange(item)"
                        >
                        </template>

                        <template v-slot:item.medical_leave="{ item }">
                        <input
                            type="checkbox"
                            v-model="item.medical_leave"
                            :disabled="item.isabsent"
                            @change="handleMedicalLeaveChange(item)"
                        >
                        </template>
                        <template v-slot:item.options="{ item }">
                        <!--  <v-text-field v-if="item.isabsent == false" class="pt-3" v-model="item.evaluated_marks" color="#0F2027" dense outlined rounded @change="check_marks(item.evaluated_marks)"></v-text-field> -->
                            <input v-if="item.isabsent == false && item.medical_leave == false" placeholder="Enter marks." class="input text-center"  type="number" v-model="item.evaluated_marks" :name="item.cid" :rules="[v => !!v || 'Required' || v >= 0]" @keypress="isNumber($event)"  @change="check_marks(item.evaluated_marks,scheme_details[0].evaluated_marks)"/>
                        </template>
                    </v-data-table>
                </span>

                 <v-row v-if="!scheme_details[0].expire">
                            <v-col cols="12" sm="12" class="d-flex justify-center">
                                <v-btn rounded class="button" disabled :loading="loader" @click="savemarksentry(scheme_details,scheme_details[0].learners)">
                                        Save
                                    </v-btn>
                            </v-col>
                             <v-col class="d-flex justify-center">
                                <span class="slide">Marks Entry Date Is Over..!</span>
                            </v-col>
                </v-row>
                <v-row v-else>
                    <v-col class="d-flex justify-center">
                        <v-btn rounded class="button" :loading="loader" @click="savemarksentry(scheme_details,scheme_details[0].learners)">
                            Save
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import * as XLSX from "xlsx";
    export default {
        props: {
            scheme_details: String,
            allow_reexam_marks_entry: String,
            tabs: String
        },
        data() {
            return {
                search:null,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ev_marks: null,
                leaner_marks_list:[],
                leaner_reexam_marks_list:[],
                leaner_marks_id_list:[],
                leaner_reexam_applied:[],
                loader:false,
                org_id:null,
                headers3: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Standard",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "PRN No",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Absent",
                        sortable: false,
                        value: "isabsent",
                    },
                    {
                        text: "Medical Leave",
                        sortable: false,
                        value: "medical_leave",
                    },
                    {
                        text: "Marks \ Grade",
                        sortable: false,
                        value: "options",
                    },
                ],
                headers4: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Standard",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "PRN No",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Is Applied For Re-exam ?",
                        sortable: false,
                        value: "is_applied_for_reexam",
                    },
                    {
                        text: "Marks \ Grade",
                        sortable: false,
                        value: "options",
                    },
                ],
            };
        },
        mounted() {
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        methods: {
             handleAbsentChange(item) {
            if (item.isabsent) {
                item.medical_leave = false
                }
            },
            handleMedicalLeaveChange(item) {
                if (item.medical_leave) {
                item.isabsent = false
                }
            },
            savemarksentry(scheme_details,learners){
                for (var i = 0; i < learners.length; i++) {
                    if (learners[i].evaluated_marks < 0) {
                        this.showSnackbar("#b71c1c", "Entered marks should be less than or equal to evaluated marks and it should be positive.");
                        return;
                    }
                    if(learners[i].evaluated_marks > scheme_details[0].evaluated_marks){
                        this.showSnackbar("#b71c1c", "Entered marks should be less than or equal to evaluated marks and it should be positive.");
                        return;
                    }
                    if(learners[i].isabsent == true && learners[i].medical_leave == true){
                        this.showSnackbar("#b71c1c", "Please select only one check box either absent or medical leave.");
                        return;
                    }

                    this.leaner_marks_id_list.push(learners[i].cid);

                    if(learners[i].isabsent == false && learners[i].medical_leave == false){
                    //  this.leaner_marks_id_list.push(learners[i].cid);
                        this.leaner_marks_list.push(learners[i].evaluated_marks); 
                    }
                    if (learners[i].isabsent == true) {
                        //this.leaner_marks_id_list.push(learners[i].cid);
                        this.leaner_marks_list.push(learners[i].isabsent); 
                    }
                    if (learners[i].medical_leave == true) {
                      //  this.leaner_marks_id_list.push(learners[i].cid);
                        this.leaner_marks_list.push("ml"); 
                    }
                    this.leaner_reexam_marks_list.push(learners[i].reexam_evaluated_marks); 
                    this.leaner_reexam_applied.push(learners[i].is_applied_for_reexam); 
                        
                }
                this.loader = true
                const data = {
                    sem:scheme_details[0].semester_id,
                    ay:scheme_details[0].academicyear_id,
                    coff_id:scheme_details[0].courseoffering_id,
                    div_off:scheme_details[0].divisionoffering_id,
                    coff_inst:scheme_details[0].courseOfferingInstructor_id,
                    assd_id:scheme_details[0].ass_det_id,
                    std:scheme_details[0].standard_id,
                    courseAssessmentScheme:scheme_details[0].courseAssessmentScheme,
                    leaner_marks_id_list:this.leaner_marks_id_list,
                    leaner_marks_list:this.leaner_marks_list,
                    leaner_reexam_marks_list:this.leaner_reexam_marks_list,
                    leaner_reexam_applied:this.leaner_reexam_applied
                }
                if (this.org_id == "wws"){
                    axios
                    .post("/WWSExamination/savemarkswithoutrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Marks Save Successfully..."); // show snackbar on success
                            if(this.org_id == "wws"){
                                this.$router.push({
                                name: "marks-entry-icse",
                            });
                            } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else{
                            this.$router.push({
                                name: "marks-entry",
                            });
                        }
                            this.loader = false
                        }
                        else{
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                       this.loader = false
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.loader = false
                        this.leaner_marks_id_list=[]
                        this.leaner_marks_list=[]
                        this.leaner_reexam_applied = []
                    });
                }else{
                    axios
                    .post("/Examination/savemarkswithoutrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Marks Save Successfully..."); // show snackbar on success
                            if(this.org_id == "wws"){
                                this.$router.push({
                                name: "marks-entry-icse",
                            });
                            }else{
                            this.$router.push({
                                name: "marks-entry",
                            });
                        }
                            this.loader = false
                        }
                    })
                    .catch((error) => {
                       this.loader = false
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.loader = false
                        this.leaner_marks_id_list=[]
                        this.leaner_reexam_marks_list =[]
                        this.leaner_marks_list=[]
                        this.leaner_reexam_applied = []
                    });
                }
                 
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },   
            check_marks(evaluated_marks,ev_marks) {
                this.ev_marks = ev_marks

              //  alert(Number(evaluated_marks))
                if (evaluated_marks > ev_marks || evaluated_marks < 0) {
                    this.showSnackbar("#b71c1c", "Entered marks should be less than or equal to evaluated marks and it should be positive.");
                    return;
                }
            },
            exportToExcel() {
                const learners = this.scheme_details[0].learners;

                if (!learners || learners.length === 0) {
                    this.showSnackbar("#b71c1c", "No data available to export.");
                    return;
                }

                const isReexam = this.allow_reexam_marks_entry && this.tabs == 1;

                const rows = learners.map((item) => {
                    if (isReexam) {
                        return {
                            "Sr. No.": item.srno,
                            "Academic Year": item.academicyear,
                            "Standard": item.std,
                            "Division": item.div,
                            "PRN No": item.registration_number,
                            "Roll No": item.rollno,
                            "Name": item.name,
                            "Is Applied For Re-exam": item.is_applied_for_reexam ? "Yes" : "No",
                            "Marks": item.is_applied_for_reexam ? item.reexam_evaluated_marks : ""
                        };
                    } else {
                        return {
                            "Sr. No.": item.srno,
                            "Academic Year": item.academicyear,
                            "Standard": item.std,
                            "Division": item.div,
                            "PRN No": item.registration_number,
                            "Roll No": item.rollno,
                            "Name": item.name,
                            "Absent": item.isabsent ? "Yes" : "No",
                            "Medical Leave": item.medical_leave ? "Yes" : "No",
                            "Marks": (!item.isabsent && !item.medical_leave) ? item.evaluated_marks : ""
                        };
                    }
                });

                const worksheet = XLSX.utils.json_to_sheet(rows);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Marks Entry");

                const colWidths = Object.keys(rows[0]).map((key) => ({
                    wch: Math.max(key.length, ...rows.map(r => String(r[key] === null || r[key] === undefined ? "" : r[key]).length)) + 2
                }));
                worksheet["!cols"] = colWidths;

                const scheme = this.scheme_details[0];
                const fileName = `Marks_${scheme.crs_code}_${scheme.standard}_${scheme.division}.xlsx`
                    .replace(/\s+/g, "_");

                XLSX.writeFile(workbook, fileName);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        }
    };
</script>
<style scoped>
    .box {
        background-color: white !important;
        margin: 8px !important;
        padding: 8px;
        border: 2px solid #0f2027 !important;
    }
    .toolbar {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: white;
    }
    .button {
        border: 2px solid #0f2027 !important;
        color: #0f2027;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
    }
    .button:hover {
        color: white;
        background: #0f2027 !important;
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    input[type=number] {
    width: 50%;
    display: inline-block;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
    }
     .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
</style>
